module.exports = __webpack_public_path__ + "public/media/step_0_pick_word.low.66507b27.mp4";